import {ChangeDetectorRef, Component, Input, OnInit} from "@angular/core";
import {ApiService} from "~/app/core/api.service";
import {OfferService} from "~/app/core/offer-service/offer.service";
import {OfferInfo} from "~/app/core/model/offer-info";
import {momentNow, toDateStr} from "~/app/core/model/date-str";
import {OfferThumbnailInfo} from "~/app/core/model/offer-thumbnail-info";
import {OfferFilter} from "~/app/core/model/offer-filter";
import {AddressInfo} from "~/app/core/model/address-info";
import {off} from "@angular/fire/database";

@Component({
  selector: "offer-list",
  templateUrl: "./offer-list.component.html",
  styleUrls: ["./offer-list.component.scss"]
})
export class OfferListComponent implements OnInit {
  @Input() offerType: string;
  @Input() offers: Array<OfferInfo>;
  @Input() filter: OfferFilter;

  constructor(
    private readonly api: ApiService,
    private readonly cd: ChangeDetectorRef,
    private readonly offerService: OfferService
  ) {
  }

  ngOnInit(): void {

  }

  private getThumbnailInfo(offerInfo: OfferInfo) {
    let offerThumbnailInfo = new OfferThumbnailInfo();
    offerThumbnailInfo.id = offerInfo.id;
    offerThumbnailInfo.company = offerInfo.companyName;
    offerThumbnailInfo.name = offerInfo.name;
    offerThumbnailInfo.image = offerInfo.imageUrl;
    offerThumbnailInfo.location = this.getLocation(offerInfo);
    offerThumbnailInfo.isFavorite = offerInfo.favorite;
    offerThumbnailInfo.isWebOffer = offerInfo.onlineOnly;
    return offerThumbnailInfo;
  }

  private getLocation(offerInfo: OfferInfo) {
    if (offerInfo.onlineOnly)
      return "Web Offer";
    else {
      for (let address of offerInfo.addresses) {
        return address.city + " ?mi";  // TODO distance
      }
    }
  }

  private getOfferThumbnails(offerList: Array<OfferInfo>) {
    let result: Array<OfferThumbnailInfo> = [];
    offerList.forEach((offer) => {
      // TODO apply filter
      result.push(this.getThumbnailInfo(offer));
    });
    return result;
  }
}


// import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnDestroy, OnInit, Output} from "@angular/core";
// import * as animation from "../../core/animation";
// import {OfferInfo} from "~/app/core/model/offer-info";
// import {InitInfo} from "~/app/core/model/init-info";
// import {OfferItemView} from "~/app/components/offer-item/offer-item-view";
// import {OfferItemAction, OfferItemActionType} from "~/app/components/offer-item/offer-item-actions";
// import * as _ from "lodash";
// import {Settings} from "~/app/core/model/settings";
// import * as Log from "~/app/core/log";
// import {InteractionType} from "~/app/core/model/interaction-type";
// import {InteractionComponent} from "~/app/core/model/interaction-component";
// import {InteractionRefType} from "~/app/core/model/interaction-ref-type";
// import {NetworkConnectionType} from "~/app/core/network.service";
// import {SponsorInfo} from "~/app/core/model/sponsor-info";
// import {LocationTracker} from "~/app/core/location.service";
// import {LocationInfo} from "~/app/core/model/location-info";
// import {UserProperty} from "~/app/core/model/user-property";
// import {InteractionTimer} from "~/app/core/interaction.service";
// import {AddressInfo} from "~/app/core/model/address-info";
// import {ActivatedRoute} from "@angular/router";
// import {BehaviorSubject} from "rxjs";
// import {momentNow, toDate, toDateStr} from "~/app/core/model/date-str";
// import {CoreService} from "~/app/core/core.service";
//
// export interface OfferShowAction {
//     offerId: number;
//     open: boolean;
//     intermission?: boolean;
//     duration?: number;
// }
//
// @Component({
//     selector: "OfferList",
//     templateUrl: "./offer-list.component.html",
//     styleUrls: ["./offer-list.component.scss"],
//     changeDetection: ChangeDetectionStrategy.OnPush
// })
// export class OfferListComponent implements OnInit, AfterViewInit, OnDestroy {
//     @Output() readonly changed: EventEmitter<number> = new EventEmitter();
//     @Output() readonly waiting: EventEmitter<boolean> = new EventEmitter();
//     @Output() readonly waitingSpinning: EventEmitter<boolean> = new EventEmitter();
//     @Output() readonly showOffer = new EventEmitter<OfferShowAction>();
//     @Output() readonly resetSearch = new EventEmitter<void>();
//     @Output() readonly tapGamification = new EventEmitter<void>();
//     @Input() readonly initOfferId: number;
//     @Input() readonly initAutoOpen: boolean;
//
//     displayTime: moment.Moment = momentNow();
//
//     initIndex: number = 0;
//     initDisableSwipe: boolean = false;
//     offerItemViews: Array<OfferItemView> = [];
//
//     currentOfferIndex: number = 0;
//     quickScroll: boolean = false;
//     openOffer: OfferInfo = null;
//     disableSwipe: boolean = false;
//     arrowIndicators: boolean = false;
//
//     @Input()
//     set offers(offers: Array<OfferInfo>) {
//         this.initOffers(offers);
//     }
//
//     get offers(): Array<OfferInfo> {
//         return this._offers;
//     }
//
//     @Input()
//     set sponsor(sponsor: SponsorInfo) {
//         this.initSponsor(sponsor);
//     }
//
//     get sponsor(): SponsorInfo {
//         return this._sponsor;
//     }
//
//     get settings(): Settings {
//         return this.core.api.device_loadSettings();
//     }
//
//     private _offers: Array<OfferInfo> = [];
//     private _sponsor: SponsorInfo = null;
//     private ready$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
//     private changeOfferList$: BehaviorSubject<void> = new BehaviorSubject(null);
//
//     private preloadWaitTimeout: number;
//     private pageRefreshTimeout: any;
//     private pageTimer: InteractionTimer;
//     private _watchLocation: LocationTracker;
//     private _longitude: number;
//     private _latitude: number;
//
//     private _easterEggSpinning = false;
//
//     constructor(
//         private readonly cd: ChangeDetectorRef,
//         private readonly zone: NgZone,
//         private readonly core: CoreService,
//         private readonly activatedRoute: ActivatedRoute,
//     ) {
//         this.quickScroll = this.settings.quickScroll;
//     }
//
//     ngOnInit(): void {
//         // select the initial index
//         const index = this.lookupOfferIndex(this.initOfferId);
//         if (index !== null) {
//             this.initIndex = index;
//             if (this.initAutoOpen) {
//                 this.initAutoOpenOffer(this.initIndex);
//             }
//         }
//     }
//
//     ngAfterViewInit(): void {
//         this.startLocationMonitoring();
//         this.stopPageRefreshInterval();
//     }
//
//     ngOnDestroy(): void {
//         this.stopLocationMonitoring();
//         if (this.preloadWaitTimeout) {
//             clearTimeout(this.preloadWaitTimeout);
//             this.preloadWaitTimeout = null;
//         }
//         if (this.pageTimer) this.pageTimer.log();
//     }
//
//     setArrows(active: boolean) {
//         this.arrowIndicators = active;
//         this.cd.markForCheck();
//     }
//
//     setSwipe(active: boolean) {
//         this.disableSwipe = !active;
//         this.cd.markForCheck();
//     }
//
//     wakeUp() {
//         Log.debug(Log.Tag.OffersList, "WAKE UP OFFERS LIST");
//         this.startLocationMonitoring();
//         this.startPageRefreshInterval();
//
//         // if (this.core.api.offers_getCurrentOfferId() != null && this.core.api.user_isAuthenticated() && this.core.api.user_isValidated()) {
//         //     Log.trace(Log.Tag.OffersList, "reload open offer");
//         //     // reload the open offer since we might be navigating back
//         //     this.autoGotoSelectAndOpen(this.core.api.offers_getCurrentOfferId());
//         // }
//
//         if (this.pageTimer) {
//             this.pageTimer.reset();
//         }
//     }
//
//     sleep() {
//         Log.debug(Log.Tag.OffersList, "SLEEP OFFERS LIST");
//         if (this.pageTimer) {
//             this.pageTimer.log(false);
//         }
//         this.stopPageRefreshInterval();
//         this.stopLocationMonitoring();
//     }
//
//     autoClose() {
//         // TODO auto-close new
//         if (this.openOffer) {
//             this.onTapClose(this.lookupOfferIndex(this.openOffer.id));
//         }
//     }
//
//     prepareImageView(offerId: number) {
//         const index = this.lookupOfferIndex(offerId);
//         if (index != null) {
//             this.updateCouponVisibility(index);
//         }
//     }
//
//     autoGotoSelect(offerId: number): Promise<void> {
//         const index = this.lookupOfferIndex(offerId);
//         // if (index != null) {
//         //     return this.slides.goTo(index);
//         // }
//         return Promise.resolve();
//     }
//
//     autoSlideSelect(offerId: number): Promise<void> {
//         const index = this.lookupOfferIndex(offerId);
//         if (index != null) {
//             // if (Log.isTrace(Log.Tag.OffersList)) {
//             //     Log.trace(Log.Tag.OffersList, "SLIDE TO " + index);
//             // }
//             // return this.slides.slideTo(index);
//         }
//         return Promise.resolve();
//     }
//
//     autoGotoSelectAndOpen(offerId: number) {
//         const index = this.lookupOfferIndex(offerId);
//         if (index != null) {
//             // this.slides.goTo(index).then(() => {
//             //     this.autoOpenOffer(index, 0);
//             // });
//         }
//     }
//
//     autoSlideSelectAndOpen(offerId: number, slideDuration?: number, openDuration?: number) {
//         const index = this.lookupOfferIndex(offerId);
//         if (index != null) {
//             const open = () => {
//                 this.autoOpenOffer(index, openDuration ? openDuration : 500);
//             };
//             // if (slideDuration) {
//             //     this.slides.slideTo(index, slideDuration).then(open);
//             // } else {
//             //     this.slides.slideTo(index).then(open);
//             // }
//         }
//     }
//
//     autoOpenOffer(index: number, duration: number = 500) {
//         this.onOpenOffer(index, duration).then(() => {
//             // do nothing
//         });
//     }
//
//     getOffer(index: number): OfferInfo {
//         return this.offers[index];
//     }
//
//     getOfferItemView(index: number): OfferItemView {
//         return this.offerItemViews[index];
//     }
//
//     onOfferSliderTouched(): void {
//         // do what?
//     }
//
//     onOfferSliderReleased(): void {
//         // do what?
//     }
//
//     onOfferViewing(index: number): void {
//         const offerItemView = this.getOfferItemView(index);
//         if (offerItemView) {
//             const offer = this.getOffer(index);
//             if (offer && offer.id > 0) {
//                 this.core.api.interactOffer(offer.id, { pgViewCount: 1 });
//                 this.core.api.offer_seenOffer(offer.id);
//                 this.pageTimer = this.core.api.interactTimerOffer(offer.id, "pgViewTime");
//             } else {
//                 this.pageTimer = null;
//             }
//         }
//     }
//
//     onOfferIndexChanged(index: number): void {
//         const lastIndex = this.currentOfferIndex;
//         const lastOffer = this.getOffer(this.currentOfferIndex);
//         if (this.pageTimer) this.pageTimer.log();
//         Log.trace(Log.Tag.OffersList, "currentOfferIndex update from " + this.currentOfferIndex + " to " + index);
//         this.currentOfferIndex = index;
//         this.changed.emit(this.currentOfferIndex);
//         const offerItemView = this.getOfferItemView(index);
//         if (offerItemView) {
//             this.pageTimer = null;
//             this.updateCouponVisibility(this.currentOfferIndex);
//             if (lastIndex > index && this.currentOfferIndex > 0) {
//                 this.updateCouponVisibility(this.currentOfferIndex - 1);
//             }
//             if (lastIndex < index && this.currentOfferIndex + 1 < this.offers.length) {
//                 this.updateCouponVisibility(this.currentOfferIndex + 1);
//             }
//         }
//     }
//
//     // offer events
//     onAction(action: OfferItemAction, index: number) {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem.id > 0) {
//             switch (action.type) {
//                 case OfferItemActionType.tapOpen:
//                     if (!this.settings.gamificationMysteryMode || offerItem.revealed) {
//                         // make sure we only treat this interaction as a tap when we know the slides are stationary
//                         const readyForBounceback = OfferItemView.isOfferReadyForBounceback(this.settings.calculateCurrentTime(), offerItem);
//                         if (readyForBounceback && !this.settings.pollThumbsUpBeforeBounceback) {
//                             console.log("READY FOR BOUNCEBACK");
//                             this.onExperienceDialogBounceBack(offerItem, "skip");
//                         } else {
//                             this.onTapOpen(index);
//                             this.core.api.interaction(InteractionType.OpenOffer, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                             this.core.api.user_setProperty(UserProperty.Viewer, "true");
//                         }
//                     }
//                     break;
//                 case OfferItemActionType.tapClose:
//                     this.onTapClose(index);
//                     this.core.api.interaction(InteractionType.CloseOffer, InteractionComponent.OfferDetails, InteractionRefType.Offer, offerItem.id);
//                     break;
//                 case OfferItemActionType.tapReveal:
//                     this.onTapReveal(index);
//                     this.core.api.interaction(InteractionType.RevealOffer, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                     break;
//                 case OfferItemActionType.tapRepeatUnlock:
//                     this.waiting.emit(true);
//                     this.core.api.interaction(InteractionType.RepeatUnlockOffer, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                     this.onTapRepeatUnlock(index).then(() => {
//                         this.waiting.emit(false);
//                     });
//                     break;
//                 case OfferItemActionType.tapFavorite:
//                     if (offerItem.favorite) {
//                         this.onTapUnfavorite(index);
//                         this.core.api.interaction(InteractionType.UnfavoriteOffer, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                     } else {
//                         this.onTapFavorite(index);
//                         this.core.api.interaction(InteractionType.FavoriteOffer, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                     }
//                     break;
//                 case OfferItemActionType.tapShowCashier:
//                     this.onShowCashier(offerItem);
//                     this.core.api.interaction(InteractionType.ReshowCashier, InteractionComponent.OfferDetails, InteractionRefType.Offer, offerItem.id);
//                     this.core.api.user_setProperty(UserProperty.Redeemer, "true");
//                     break;
//                 case OfferItemActionType.tapShare:
//                     if (this.settings.quickShare) {
//                         this.core.api.interaction(InteractionType.ShareStandard, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                         this.core.api.interactOffer(offerItem.id, { tapShareCount: 1 });
//                         this.waiting.emit(true);
//                         this.core.share.doShareStandard(offerItem, (result) => {
//                             if (result) {
//                                 this.core.api.tickets_sharedOffer();
//                             }
//                             this.waiting.emit(false);
//                         });
//                     } else {
//                         this.core.api.interaction(InteractionType.PrepareShare, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                         this.setArrows(false);
//                         this.core.nav.navPageShare(offerItem.id);
//                     }
//                     break;
//                 case OfferItemActionType.tapWebsite:
//                     if (offerItem.companyWebUrl) {
//                         this.core.api.interaction(InteractionType.MerchantWebsite, InteractionComponent.OfferDetails, InteractionRefType.Merchant, offerItem.companyId);
//                         Log.debug(Log.Tag.OffersList, "Open website");
//                         this.core.api.interactOffer(offerItem.id, { tapWebsiteCount: 1 });
//                         const subscription = this.core.suspend.statusObservable().subscribe((status) => {
//                             if (status === "resume") {
//                                 this.core.api.tickets_websiteVisit();
//                                 subscription.unsubscribe();
//                             }
//                         });
//                         if (this.core.net.connectionType === NetworkConnectionType.None) {
//                             this.waiting.emit(true);
//                             this.waitingSpinning.emit(false);
//                             this.handleNoData(offerItem, "website", () => {
//                                 this.waiting.emit(false);
//                                 this.waitingSpinning.emit(true);
//                                 window.open(offerItem.companyWebUrl, '_blank');
//                             });
//                         } else {
//                             window.open(offerItem.companyWebUrl, '_blank');
//                         }
//                     }
//                     break;
//                 case OfferItemActionType.tapMap:
//                     this.core.api.interaction(InteractionType.MerchantDirections, InteractionComponent.OfferDetails, InteractionRefType.Offer, offerItem.id);
//                     this.core.api.interactOffer(offerItem.id, { tapDirectionsCount: 1 });
//                     const addr = action.data as AddressInfo;
//                     if (this.core.net.connectionType === NetworkConnectionType.None) {
//                         this.waiting.emit(true);
//                         this.waitingSpinning.emit(false);
//                         this.handleNoData(offerItem, "directions", () => {
//                             this.waiting.emit(false);
//                             this.waitingSpinning.emit(true);
//                             this.core.nav.navMapDirections(addr.street1 + ", " + addr.city + ", " + addr.state + ", " + addr.zip);
//                         });
//                     } else {
//                         this.core.nav.navMapDirections(addr.street1 + ", " + addr.city + ", " + addr.state + ", " + addr.zip);
//                     }
//                     break;
//                 case OfferItemActionType.tapPhone:
//                     window.open("tel:" + action.data as string, '_blank');
//                     break;
//                 case OfferItemActionType.tapThumbsUp:
//                     this.core.api.interaction(InteractionType.ThumbsUp, InteractionComponent.ThumbsUpDown, InteractionRefType.Offer, offerItem.id);
//                     this.onExperienceDialogBounceBack(offerItem, "up");
//                     break;
//                 case OfferItemActionType.tapThumbsDown:
//                     this.core.api.interaction(InteractionType.ThumbsDown, InteractionComponent.ThumbsUpDown, InteractionRefType.Offer, offerItem.id);
//                     this.onExperienceDialogBounceBack(offerItem, "down");
//                     break;
//                 case OfferItemActionType.tapReview:
//                     this.core.api.interaction(InteractionType.MerchantReviewSite, InteractionComponent.OfferDetails, InteractionRefType.Merchant, offerItem.companyId);
//                     this.core.api.interactOffer(offerItem.id, { tapReviewCount: 1 });
//                     if (offerItem.reviewUrl) {
//                         window.open(offerItem.reviewUrl, '_blank');
//                     }
//                     break;
//                 case OfferItemActionType.whenMinimizing:
//                     break;
//                 case OfferItemActionType.whenMinimized:
//                     break;
//                 case OfferItemActionType.whenExpanding:
//                     break;
//                 case OfferItemActionType.whenExpanded:
//                     if (this.isOfferNeedToPlaySponsorVideo(offerItem)) {
//                         this.core.nav.navPageSponsorVideo(offerItem.id);
//                     }
//                     break;
//                 case OfferItemActionType.testThanks:
//                     this.core.nav.navPageThanks(offerItem.id, "slideLeft");
//                     break;
//                 case OfferItemActionType.testShowCashier:
//                     this.core.nav.navPageShowCashier(offerItem.id, true, true);
//                     break;
//                 case OfferItemActionType.testResetOfferRedeemed:
//                 case OfferItemActionType.testResetOfferRevealed:
//                 case OfferItemActionType.testResetOfferRepeatUnlocked:
//                 case OfferItemActionType.testResetOfferBounceback:
//                 case OfferItemActionType.testResetOfferThumbs:
//                 case OfferItemActionType.testResetOfferVideo:
//                     this.waiting.emit(true);
//                     this.onTapClose(index).then(() => {
//                         this.core.api.test_resetOffer(
//                             offerItem.id,
//                             action.type === OfferItemActionType.testResetOfferRedeemed,
//                             action.type === OfferItemActionType.testResetOfferRevealed,
//                             action.type === OfferItemActionType.testResetOfferRepeatUnlocked,
//                             action.type === OfferItemActionType.testResetOfferThumbs,
//                             action.type === OfferItemActionType.testResetOfferBounceback,
//                             action.type === OfferItemActionType.testResetOfferVideo
//                         ).then((offer) => {
//                             this.offers[index] = this.core.api.offers_getOffer(offerItem.id);
//                             this.updateAvailability(this.lookupOfferIndex(offerItem.id));
//                             this.changeOfferList$.next(null);
//                             this.waiting.emit(false);
//                             this.showOffer.emit({ offerId: offerItem.id, open: false, intermission: true, duration: 1250 });
//                         }, (error) => {
//                             this.waiting.emit(false);
//                         });
//                     }, (error) => {
//                         this.waiting.emit(false);
//                     });
//                     break;
//             }
//         } else {
//             switch (action.type) {
//                 case OfferItemActionType.tapShareApp:
//                     this.core.api.interaction(InteractionType.ShareApp, InteractionComponent.OffersPage);
//                     this.waiting.emit(true);
//                     this.core.share.doShareStandard(null, (result) => {
//                         console.log("RESULT: " + result);
//                         if (result) {
//                             this.core.api.tickets_sharedOffer();
//                         }
//                         this.waiting.emit(false);
//                     });
//                     break;
//                 case OfferItemActionType.tapMerchantContact:
//                     this.core.nav.navPageContactUs("merchants");
//                     break;
//                 case OfferItemActionType.tapResetSearch:
//                     this.resetSearch.emit();
//                     break;
//             }
//         }
//     }
//
//     private initOffers(newOffers: Array<OfferInfo>): Promise<void> {
//         this.ready$.next(false);
//         const oldOffers = this.offers;
//         if (!_.isEqual(oldOffers, newOffers) && newOffers !== null) {
//             this._offers = newOffers;
//             this.openOffer = null;
//             this.disableSwipe = false;
//             this.changeOfferList$.next(null);
//
//             return new Promise((resolve) => {
//                 let subscription = null;
//                 // if (this.slides && this.slides.changeSlides()) {
//                 //     subscription = this.slides.changeSlides().subscribe(() => {
//                 //         if (Log.isTrace(Log.Tag.OffersList)) {
//                 //             Log.trace(Log.Tag.OffersList, "changed slides");
//                 //             Log.trace(Log.Tag.OffersList, "num slides: " + this.slides.getNumSlides());
//                 //         }
//                 //         resolve();
//                 //         // this seems clunky, but trying to avoid: ERROR Error: Uncaught (in promise): ObjectUnsubscribedError: object unsubscribed
//                 //         subscription.unsubscribe();
//                 //     });
//                 // }
//
//                 const useMysteries = !!this.settings.gamificationMysteryMode;
//                 this.offerItemViews = [];
//                 this.offers.forEach((offer) => {
//                     const view = new OfferItemView();
//                     view.visible = false;
//                     view.showMystery = useMysteries && !offer.revealed;
//                     view.showExpiration = true;
//                     this.offerItemViews.push(view);
//                 });
//                 this.updateCouponVisibility(this.currentOfferIndex);
//                 if (!subscription) {
//                     resolve();
//                 }
//             });
//         } else {
//             // no offers, so redirect to search page
//             // TODO make sure the redirect happens from offers page
//             // this.core.nav.navPageSearch(false);
//             return Promise.resolve();
//         }
//     }
//
//     private initSponsor(newSponsor: SponsorInfo) {
//         this._sponsor = newSponsor;
//     }
//
//     private updateAvailability(index: number) {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem && offerItem.id > 0) {
//             const offerItemView: OfferItemView = this.getOfferItemView(index);
//             const expired = OfferItemView.calculateDaysRemaining(this.settings.calculateCurrentTime(), offerItem) === 0;
//             const originalShowRedeemNow = offerItemView.showRedeemNow ? offerItemView.showRedeemNow : false;
//
//             const updateShowRedeemNow = (showRedeemNow: boolean, nearestAddressId: number = null, milesAway: number = null, city: string = null, unavailable: boolean = false) => {
//                 // since this is in a callback, make sure we load the latest offer item view before modifying it
//                 const existingOfferItemView = this.getOfferItemView(index);
//                 if (existingOfferItemView && (unavailable !== existingOfferItemView.unavailable || existingOfferItemView.showRedeemNow !== showRedeemNow || existingOfferItemView.milesAway !== milesAway)) {
//                     const newOfferItemView: OfferItemView = new OfferItemView();
//                     // make a copy of it so that angular refreshes everything...
//                     newOfferItemView.deserialize(existingOfferItemView);
//                     if (showRedeemNow) {
//                         this.core.api.offer_nearbyOffer(offerItem.id, nearestAddressId);
//                     }
//                     newOfferItemView.showRedeemNow = showRedeemNow;
//                     if (this.settings.showMilesAwayOnCoupon) {
//                         newOfferItemView.milesAway = !milesAway ? null : (milesAway > 1 ? Math.round(milesAway) : Math.round(milesAway * 10) / 10);
//                         newOfferItemView.city = city;
//                     }
//                     newOfferItemView.unavailable = unavailable;
//                     if (newOfferItemView.unavailable) {
//                         Log.trace(Log.Tag.OffersList, "unavailable: " + offerItem.id);
//                     }
//                     this.offerItemViews[index] = newOfferItemView;
//                     this.changeOfferList$.next(null);
//                 }
//             };
//
//             const available = !this.settings.gamificationEnabled || offerItem.revealed;
//
//             const redeemed = OfferItemView.isOfferRedeemed(offerItem, this.settings.calculateCurrentTime());
//             const repeatUnlockable = this.settings.gamificationEnabled && OfferItemView.isOfferRepeatUnlockable(offerItem, this.settings.calculateCurrentTime());
//             const redeemable = !repeatUnlockable && !redeemed && !expired;
//             if (redeemable) {
//                 const nearest = this.nearestAddress(offerItem);
//                 const nearestCity: string = nearest ? nearest.city : null;
//                 const nearestAddressId: number = nearest ? nearest.addressId : null;
//                 const distancePrecise = this.milesAwayPrecise(nearest);
//                 Log.trace(Log.Tag.OffersList, "distance: " + distancePrecise);
//                 if (distancePrecise != null && distancePrecise <= this.settings.redeemNowMiles) {
//                     // only showRedeemNow if other redeemable logic passes
//                     const net = this.core.net.connectionType !== NetworkConnectionType.None;
//                     if (!expired && !this.core.api.user_isAuthenticated()) {
//                         if (!originalShowRedeemNow) {
//                             this.core.api.interaction(InteractionType.EnableRedeemNow, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                         }
//                         updateShowRedeemNow(available && true, nearestAddressId, distancePrecise, nearestCity);
//                     } else if (!net) {
//                         updateShowRedeemNow(available && !this.settings.enforceRedeemNet, nearestAddressId, distancePrecise, nearestCity);
//                         if (offerItemView && offerItemView.showRedeemNow && !originalShowRedeemNow) {
//                             this.core.api.interaction(InteractionType.EnableRedeemNow, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                         }
//                     } else {
//                         // the offer can be redeemed UNLESS the server says no for some reason
//                         this.core.api.offers_isAvailableOffer(offerItem.id).then((result) => {
//                             updateShowRedeemNow(available && result.available, nearestAddressId, distancePrecise, nearestCity, !result.available);
//                             if (result && !originalShowRedeemNow) {
//                                 this.core.api.interaction(InteractionType.EnableRedeemNow, InteractionComponent.OffersPage, InteractionRefType.Offer, offerItem.id);
//                             }
//                         }, (error) => {
//                             updateShowRedeemNow(false);
//                         });
//                     }
//                 } else {
//                     updateShowRedeemNow(false, null, distancePrecise, nearestCity);
//                 }
//             } else {
//                 updateShowRedeemNow(false);
//             }
//         }
//     }
//
//     private hasMilesAway(offerInfo: OfferInfo): boolean {
//         return offerInfo.addresses && offerInfo.addresses.length > 0 && !!offerInfo.addresses[0].latitude && !!offerInfo.addresses[0].longitude && !!this._longitude && !!this._latitude;
//     }
//
//     private nearestAddress(offerInfo: OfferInfo): AddressInfo {
//         let minAddress: AddressInfo = null;
//         if (this.hasMilesAway(offerInfo)) {
//             let minDistance = null;
//             offerInfo.addresses.forEach((addr) => {
//                 if (addr.longitude && addr.latitude) {
//                     const distance = LocationInfo.milesAway(
//                         { longitude: addr.longitude, latitude: addr.latitude },
//                         { longitude: this._longitude, latitude: this._latitude }
//                     );
//                     if (distance !== null) {
//                         if (!minDistance || distance < minDistance) {
//                             minDistance = distance;
//                             minAddress = addr;
//                         }
//                     }
//                 }
//             });
//         }
//         return minAddress;
//     }
//
//     private milesAwayPrecise(address: AddressInfo): number {
//         if (address) {
//             const distance = LocationInfo.milesAway(
//                 { longitude: address.longitude, latitude: address.latitude },
//                 { longitude: this._longitude, latitude: this._latitude }
//             );
//             return distance;
//         }
//         return null;
//     }
//
//     private onTapClose(index: number, duration?: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem && offerItem.id > 0) {
//             return this.onCloseOffer(index, duration ? duration : 500);
//         }
//     }
//
//     private onTapReveal(index: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (this.core.net.connectionType === NetworkConnectionType.None) {
//             this.handleNoData(offerItem, "reveal");
//             return Promise.resolve();
//         }
//
//         if (offerItem && offerItem.id > 0) {
//             if (!offerItem.revealed && offerItem.revealCost > this.core.api.tickets_getTicketCount()) {
//                 // not enough tickets, so show the gamification screen
//                 return new Promise((resolve) => {
//                     this.core.toast.toastError({
//                         header: "Not Enough Tickets",
//                         message: "You need to acquire more tickets before you can unlock this offer.\n\nTap here to find out how.",
//                         duration: 2500,
//                         onHide: () => {
//                             resolve();
//                         }
//                     });
//                 });
//             } else {
//                 return new Promise((resolve) => {
//                     this.core.api.offers_revealOffer(offerItem.id).then(info => {
//                         if (info.revealed) {
//                             this.onOpenOffer(index, 2500).then(() => {
//                                 offerItem.revealed = true;
//                                 this.getOfferItemView(index).showMystery = false;
//                                 this.cd.markForCheck();
//                                 resolve();
//                             });
//                         } else {
//                             // just don't reveal
//                             resolve();
//                         }
//                     }, (error) => {
//                         // TODO how to handle an error revealing the offer?
//                         resolve();
//                     });
//                 });
//             }
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private onTapRepeatUnlock(index: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (this.core.net.connectionType === NetworkConnectionType.None) {
//             this.handleNoData(offerItem, "repeatUnlock");
//             return Promise.resolve();
//         }
//
//         if (offerItem && offerItem.id > 0) {
//             if (!offerItem.repeatUnlocked && offerItem.repeatUnlockCost > this.core.api.tickets_getTicketCount()) {
//                 // not enough tickets, so show the gamification screen
//                 return new Promise((resolve) => {
//                     this.core.toast.toastError({
//                         header: "Not Enough Tickets",
//                         message: "You need to acquire more tickets before you can re-use this offer.\n\nTap here to find out how.",
//                         duration: 2500,
//                         onHide: () => {
//                             resolve();
//                         }
//                     });
//                 });
//             } else {
//                 return new Promise((resolve) => {
//                     this.onCloseOffer(index).then(() => {
//                         this.core.api.offers_repeatUnlockOffer(offerItem.id).then(info => {
//                             this.offers[index] = info;
//                             this.onOpenOffer(index).then(() => {
//                                 resolve();
//                             }, (error) => {
//                                 resolve();
//                             });
//                         }, (error) => {
//                             this.core.toast.toastError({
//                                 header: "Problem Unlocking Offer",
//                                 message: "We're sorry. Something went wrong unlocking this offer for re-user.",
//                                 duration: 2500
//                             });
//                             resolve();
//                         });
//                     }, (error) => {
//                         resolve();
//                     });
//                 });
//             }
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private onTapFavorite(index: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (this.core.net.connectionType === NetworkConnectionType.None) {
//             this.handleNoData(offerItem, "favorite");
//             return Promise.resolve();
//         }
//
//         if (offerItem && offerItem.id > 0) {
//             if (!offerItem.favorite && offerItem.favoriteCost > this.core.api.tickets_getTicketCount()) {
//                 // not enough tickets, so show the gamification screen
//                 return new Promise((resolve) => {
//                     this.core.toast.toastError({
//                         header: "Not Enough Tickets",
//                         message: "You need to acquire more tickets before you can favorite this offer.\n\nTap here to find out how.",
//                         duration: 2500,
//                         onHide: () => {
//                             resolve();
//                         }
//                     });
//                 });
//             } else {
//                 return new Promise((resolve) => {
//                     let nextOfferId = offerItem.id;
//                     if (index < this._offers.length) nextOfferId = this._offers[index + 1].id;
//                     else if (index > 0) nextOfferId = this._offers[index - 1].id;
//                     return this.onCloseOffer(index).then(() => {
//                         this.core.api.offers_favoriteOffer(offerItem.id).then(info => {
//                             if (info.favorite) {
//                                 this.showOffer.emit({ offerId: nextOfferId, open: false, intermission: true, duration: 1250 });
//                                 resolve();
//                             } else {
//                                 resolve();
//                             }
//                         }, (error) => {
//                             // TODO how to handle an error revealing the offer?
//                             resolve();
//                         });
//                     });
//                 });
//             }
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private onTapUnfavorite(index: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem && offerItem.id > 0) {
//             if (offerItem.favorite) {
//                 this.core.dialogs.confirm({
//                     title: "Unfavorite Offer",
//                     message: "Are you sure you want to remove this offer from your favorites?",
//                     okButtonText: "Unfavorite",
//                     cancelButtonText: "Cancel"
//                 }).then((result) => {
//                     if (result === true) {
//                         return new Promise((resolve) => {
//                             let nextOfferId = offerItem.id;
//                             if (index < this._offers.length - 1) nextOfferId = this._offers[index + 1].id;
//                             else if (index > 0) nextOfferId = this._offers[index - 1].id;
//                             return this.onCloseOffer(index).then(() => {
//                                 this.core.api.offers_unfavoriteOffer(offerItem.id).then(info => {
//                                     if (!info.favorite) {
//                                         this.showOffer.emit({ offerId: nextOfferId, open: false, intermission: true, duration: 1250 });
//                                         resolve(null);
//                                     } else {
//                                         resolve(null);
//                                     }
//                                 }, (error) => {
//                                     // TODO how to handle an error revealing the offer?
//                                     resolve(null);
//                                 });
//                             });
//                         });
//                     }
//                 });
//             }
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private onTapOpen(index: number): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem && offerItem.id > 0) {
//             if (this.core.api.user_needsValidation()) {
//                 this.core.nav.navPageValidate(offerItem.id, true);
//             } else if (this.core.api.user_isAuthenticated()) {
//                 return this.onOpenOffer(index);
//             } else {
//                 this.waiting.emit(true);
//                 this.waitingSpinning.emit(false);
//                 this.core.toast.toastInfo({
//                     header: "Sign In",
//                     message: "Before we can share these offers with you, please take a moment to sign in.",
//                     onHide: () => {
//                         this.waiting.emit(false);
//                         this.waitingSpinning.emit(true);
//                         setTimeout(() => {
//                             // do this in a timeout in order for the waiting notification to be handled in ios to prevent screen lockup on a back button
//                             const info: InitInfo = this.core.api.device_info();
//                             if (info && info.showLogin) {
//                                 this.core.nav.navPageLogin(offerItem.id, true);
//                             } else {
//                                 this.core.nav.navPageRegister(offerItem.id, true);
//                             }
//                         }, 10);
//                     }
//                 });
//             }
//         }
//     }
//
//     // end offer events
//
//     private onShowCashier(offer: OfferInfo): void {
//         if (!offer.redeemedDate && offer.id > 0) {
//             // not yet redeemed, so attempt to officially redeem before showing cashier
//             this.waiting.emit(true);
//             const nearest = this.nearestAddress(offer);
//             const nearestAddressId: number = nearest ? nearest.addressId : null;
//             this.core.api.offers_redeemOffer(offer.id, nearestAddressId).then((info) => {
//                 if (info.redeemedDate) {
//                     if (info.onlineOnly) {
//                         this.handleNoData(offer, "onlineRedeem", () => {
//                             this.waiting.emit(false);
//                             this.waitingSpinning.emit(true);
//                             this.showOffer.emit({ offerId: offer.id, open: true });
//                             window.open(offer.onlineRedeemUrl, '_blank');
//
//                             const subscription = this.core.suspend.statusObservable().subscribe((status) => {
//                                 if (status === "resume") {
//                                     this.core.api.tickets_redeemedOnlineOffer(info.id);
//                                     subscription.unsubscribe();
//                                 }
//                             });
//                         });
//                     } else {
//                         const view = this.getOfferItemView(this.lookupOfferIndex(offer.id));
//                         this.core.api.tickets_redeemedLocalOffer(info.id, nearestAddressId, view.milesAway).then(() => {
//                             this.core.nav.navPageShowCashier(info.id);
//                         });
//                     }
//                 }
//                 this.waiting.emit(false);
//             }, (error) => {
//                 // popup error message
//                 this.core.toast.toastError({
//                     header: "Failed to Redeem",
//                     message: "Oh no! Something went wrong while redeeming this offer. Try again."
//                 });
//                 this.waiting.emit(false);
//             });
//         } else {
//             // already redeemed, so just show cashier page
//             if (offer.onlineOnly) {
//                 this.handleNoData(offer, "website", () => {
//                     this.waiting.emit(false);
//                     this.waitingSpinning.emit(true);
//                     window.open(offer.onlineRedeemUrl, '_blank');
//                 });
//             } else {
//                 this.core.nav.navPageShowCashier(offer.id, true);
//             }
//         }
//     }
//
//     private onExperienceDialogBounceBack(offer: OfferInfo, thumbs: "up"|"down"|"skip"): void {
//         if (offer && offer.id > 0) {
//             const bounceBackOffer = offer.bounceBackOfferId;
//             this.waiting.emit(true);
//             const result = this.core.api.offers_recordOfferExperience(offer.id, thumbs);
//             if (result.success) {
//                 offer.thumbs = thumbs;
//                 offer.thumbsDate = toDateStr(this.settings.calculateCurrentTime());
//                 this.core.api.interaction(InteractionType.SeeBounceback, InteractionComponent.ThumbsUpDown, InteractionRefType.Offer, offer.id);
//                 offer = this.core.api.offers_getOffer(offer.id);
//                 this.waiting.emit(false);
//                 this.onTapClose(this.currentOfferIndex, 500).then(() => {
//                     this.showOffer.emit({ offerId: bounceBackOffer, open: true });
//                 });
//             } else {
//                 this.core.toast.toastError({
//                     header: "Unable to Bounce Back",
//                     message: "Oh no! We're having a problem getting your new offer. Please try again."
//                 });
//             }
//         }
//     }
//
//     private onCloseRedeem(): void {
//     }
//
//     private initAutoOpenOffer(index: number) {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (offerItem) {
//             this.initDisableSwipe = true;
//             this.disableSwipe = true;
//             this.openOffer = offerItem;
//             this.updateExpandFraction(1, index);
//         }
//     }
//
//     private onOpenOffer(index: number, duration: number = 500): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//         if (!this.disableSwipe && offerItem && offerItem.id > 0) {
//             Log.debug(Log.Tag.OffersList, "OPEN OFFER: " + offerItem.id);
//             this.core.api.interactOffer(offerItem.id, { pgOpenCount: 1 });
//             if (this.pageTimer) this.pageTimer.log();
//             this.pageTimer = this.core.api.interactTimerOffer(offerItem.id, "pgOpenTime");
//             this.openOffer = offerItem;
//             this.setSwipe(false);
//             if (duration > 0) {
//                 return new Promise((resolve, reject) => {
//                     if (this.isOfferNeedToPlaySponsorVideo(offerItem)) {
//                         this.core.nav.navPageSponsorVideo(offerItem.id);
//                     }
//                     this.core.nav.navPageOffer(offerItem.id);
//                     resolve();
//                 });
//             } else {
//                 if (this.isOfferNeedToPlaySponsorVideo(offerItem)) {
//                     this.core.nav.navPageSponsorVideo(offerItem.id);
//                 }
//                 this.updateExpandFraction(1, index);
//                 return Promise.resolve();
//             }
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private onCloseOffer(index: number, duration: number = 500): Promise<void> {
//         const offerItem: OfferInfo = this.getOffer(index);
//
//         if (this.disableSwipe && offerItem && offerItem.id > 0) {
//             if (this.pageTimer) this.pageTimer.log();
//             this.pageTimer = this.core.api.interactTimerOffer(offerItem.id, "pgViewTime");
//             this.openOffer = null;
//             this.setSwipe(true);
//             return Promise.resolve();
//         } else {
//             return Promise.resolve();
//         }
//     }
//
//     private isOfferNeedToPlaySponsorVideo(offerInfo: OfferInfo): boolean {
//         if (offerInfo && offerInfo.id > 0 && !offerInfo.redeemedDate && !offerInfo.watchedVideo && !offerInfo.sample && this.sponsor && this.sponsor.videoUrl) {
//             const currentDate = this.settings.calculateCurrentTime();
//             const daysRemaining = OfferItemView.calculateDaysRemaining(currentDate, offerInfo);
//             if (daysRemaining > 0) {
//                 // see if when the next video should be played
//                 const nextDate = toDate(this.settings.sponsorVideoNext);
//                 // console.log("NEXT DATE: " + this.settings.sponsorVideoNext);
//                 if (currentDate.getTime() > nextDate.getTime()) {
//                     return true;
//                 } else if (offerInfo.free) {
//                     return true;
//                 }
//             }
//         }
//         return false;
//     }
//
//     private animateSponsorOfferAdGrid(forward: boolean, millis: number, index: number): Promise<void> {
//         return new Promise((resolve, reject) => {
//             const progressFunction = (fraction) => {
//                 this.updateExpandFraction(fraction, index);
//             };
//             if (forward) {
//                 animation.animateForward(millis, progressFunction).watch().then(() => resolve());
//             } else {
//                 animation.animateReverse(millis, progressFunction).watch().then(() => resolve());
//             }
//         });
//     }
//
//     private updateExpandFraction(fraction: number, index: number) {
//         const offerItemView = this.getOfferItemView(index);
//         if (offerItemView) {
//             const newOfferItemView: OfferItemView = new OfferItemView();
//             newOfferItemView.deserialize(offerItemView);
//             newOfferItemView.lastFraction = newOfferItemView.fraction;
//             newOfferItemView.fraction = fraction;
//             this.offerItemViews[index] = newOfferItemView;
//             this.changeOfferList$.next(null);
//         }
//     }
//
//     private updateCouponVisibility(centerIndex: number) {
//         this.updateAvailability(centerIndex);
//         this.offerItemViews.forEach((view, index) => {
//             const visible: boolean = index >= centerIndex - 1 && index <= centerIndex + 1;
//             if (visible !== view.visible) {
//                 // change visibility
//                 const newOfferItemView: OfferItemView = new OfferItemView();
//                 newOfferItemView.deserialize(view);
//                 newOfferItemView.visible = visible;
//                 this.offerItemViews[index] = newOfferItemView;
//                 this.changeOfferList$.next(null);
//             }
//         });
//     }
//
//     private lookupOfferIndex(offerId: number) {
//         if (this.offers) {
//             let idx = 0;
//             for (const offer of this.offers) {
//                 if (offer.id === offerId) {
//                     return idx;
//                 }
//                 idx++;
//             }
//         }
//         return null;
//     }
//
//     private startLocationMonitoring() {
//         if (!this._watchLocation) {
//             this._watchLocation = this.core.location.startWatchingLocationInfo((where) => {
//                 if (where) {
//                     const firstLoc = !this._longitude;
//                     this._longitude = where.longitude;
//                     this._latitude = where.latitude;
//                     Log.trace(Log.Tag.OffersList, "watchlong, watchlat: " + this._longitude + ", " + this._latitude);
//                     if (firstLoc) {
//                         if (this.settings.showMilesAwayOnCoupon) {
//                             this.offers.forEach((offer, index) => {
//                                 const view = this.getOfferItemView(index);
//                                 const nearest = this.nearestAddress(offer);
//                                 const milesAway = this.milesAwayPrecise(nearest);
//                                 view.milesAway = !milesAway ? null : (milesAway > 1 ? Math.round(milesAway) : Math.round(milesAway * 10) / 10);
//                                 view.city = nearest ? nearest.city : null;
//                             });
//                         }
//                     }
//                 } else {
//                     this._longitude = null;
//                     this._latitude = null;
//                 }
//                 this.updateAvailability(this.currentOfferIndex);
//             });
//         }
//     }
//
//     private stopLocationMonitoring() {
//         if (this._watchLocation) {
//             this.core.location.stopWatchingLocationInfo(this._watchLocation);
//             this._watchLocation = null;
//         }
//     }
//
//     private handleNoData(offerInfo: OfferInfo, type: "reveal" | "repeatUnlock" | "favorite" | "directions" | "website" | "sponsor" | "onlineRedeem", onHide: () => void = null) {
//         if (type === "reveal") {
//             this.core.toast.toastError({
//                 header: "No Data",
//                 message: "Sorry! We can't reveal this offer without data or wi-fi available.\n\nPlease enable data and try again.",
//                 onHide
//             });
//         } else if (type === "repeatUnlock") {
//                 this.core.toast.toastError({
//                     header: "No Data",
//                     message: "Sorry! We can't re-use this offer without data or wi-fi available.\n\nPlease enable data and try again.",
//                     onHide
//                 });
//         } else if (type === "favorite") {
//             this.core.toast.toastError({
//                 header: "No Data",
//                 message: "Sorry! We can't favorite this offer without data or wi-fi available.\n\nPlease enable data and try again.",
//                 onHide
//             });
//         } else if (type === "website") {
//             this.core.toast.toastInfo({
//                 header: "About " + offerInfo.companyName,
//                 message: "We're about to take you to the " + offerInfo.companyName + " website. Don't forget to enable wi-fi or data.\n\nThanks!",
//                 onHide
//             });
//         } else if (type === "directions") {
//             this.core.toast.toastInfo({
//                 header: "Need Directions?",
//                 message: "We might have trouble routing you to " + offerInfo.companyName + " without data or wi-fi available.\n\nIf you have trouble, don't forget to enable data and try again.",
//                 onHide
//             });
//         } else if (type === "sponsor") {
//             if (this.sponsor) {
//                 this.core.toast.toastInfo({
//                     header: "About " + this.sponsor.name,
//                     message: "We're about to show you more information about " + this.sponsor.name + ".\n\nDon't forget to enable wi-fi or data.\n\nThanks!",
//                     onHide
//                 });
//             }
//         } else if (type === "onlineRedeem") {
//             this.core.toast.toastInfo({
//                 header: "Redeem Online Offer",
//                 message: "We're sending you to the " + offerInfo.companyName + " website to redeem your offer. Don't forget to enable wi-fi or data.\n\nThanks!",
//                 onHide
//             });
//         }
//     }
//
//     private startPageRefreshInterval() {
//         if (!this.pageRefreshTimeout) {
//             const now = momentNow();
//             const second = now.second();
//             const timeout = (60 - second) * 1000;
//             // const timeout = 1000;
//             this.pageRefreshTimeout = setTimeout(() => {
//                 this.pageRefreshTimeout = null;
//                 this.displayTime = momentNow();
//                 this.changeOfferList$.next(null);
//                 this.cd.detectChanges();
//                 this.startPageRefreshInterval();
//             }, timeout);
//         }
//     }
//
//     private stopPageRefreshInterval() {
//         if (this.pageRefreshTimeout) {
//             clearTimeout(this.pageRefreshTimeout);
//             this.pageRefreshTimeout = null;
//         }
//     }
// }
